import { useUpdateVenueOverviewVersion } from '@api';
import { useNotification } from '@common';
import { useRouter } from '@tanstack/react-router';
import { AxiosError } from 'axios';

const TRANS_KEY = 'NOTIFICATIONS.EDIT_VERSION';

export type EditVersionArgsType = {
  oldVersion: string;
  newVersion: string;
};

type UseEditVersionReturnType = {
  editVersion: (data: EditVersionArgsType) => Promise<void>;
};

export const useEditOverviewVersion = ({
  venueId,
}: {
  venueId: string;
}): UseEditVersionReturnType => {
  const { mutateAsync } = useUpdateVenueOverviewVersion();
  const { showError, showSuccess } = useNotification();
  const router = useRouter();

  const onSuccess = (newVersion: string) => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
    router.navigate({
      to: '/venues/$id/overview/$version',
      params: { id: venueId, version: newVersion },
    });
  };

  const onError = (error: AxiosError) => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error: error,
    });
  };

  const editVersion = async ({
    oldVersion,
    newVersion,
  }: EditVersionArgsType) => {
    await mutateAsync(
      {
        venueId,
        overviewVersion: oldVersion,
        data: {
          version: newVersion,
        },
      },
      {
        onSuccess: () => onSuccess(newVersion),
        onError,
      }
    );
  };

  return { editVersion };
};
